/**
 * Number of questions a learner gets per attempt.
 * Uses the admin's per-difficulty selection when enabled, else every question (legacy flow).
 */
export const getExamQuestionCount = (exam: any): number => {
  const selection = exam?.question_selection;
  if (selection?.enabled && Number(selection.total_count) > 0) {
    return Number(selection.total_count);
  }
  return exam?.questions?.length || 0;
};

/**
 * Points a learner can earn per attempt, as "26" or "20–32" when the random picks vary in points.
 * Mirrors the server pick: per difficulty, the N lowest-point to N highest-point questions.
 */
export const getExamTotalPointsLabel = (exam: any): string => {
  const selection = exam?.question_selection;
  const questions: any[] = (exam?.questions || []).filter((q: any) => !q?.is_deleted);
  if (!selection?.enabled || Number(selection.total_count) <= 0 || questions.length === 0) {
    return String(exam?.total_points ?? 0);
  }

  const requested: Record<'easy' | 'medium' | 'hard', number> = {
    easy: Number(selection.easy_count) || 0,
    medium: Number(selection.medium_count) || 0,
    hard: Number(selection.hard_count) || 0,
  };

  let min_points = 0;
  let max_points = 0;
  (Object.keys(requested) as Array<'easy' | 'medium' | 'hard'>).forEach((level) => {
    const points = questions
      .filter((q) => (q?.difficulty_level || '').toString().toLowerCase() === level)
      .map((q) => Number(q?.points) || 0)
      .sort((a, b) => a - b);
    const count = Math.min(requested[level], points.length);
    min_points += points.slice(0, count).reduce((sum, p) => sum + p, 0);
    max_points += points.slice(points.length - count).reduce((sum, p) => sum + p, 0);
  });

  return min_points === max_points ? String(min_points) : `${min_points}–${max_points}`;
};
